import useSWR from "swr";

const useCustomer = (id) => useSWR(id ? `/customers/${id}` : null);

export default useCustomer;
